import { useNavigate } from 'react-router-dom'
import { messageTimeLabel, useConversations } from '@carrent/domain'
import { ConversationListItem, Icon, PageHeader } from '@carrent/ui'

/**
 * Диалоги водителя.
 *
 * Одна колонка, строки во всю ширину — мобильная композиция.
 * Название личного диалога — имя собеседника: своё имя в списке
 * своих чатов бесполезно.
 */

function conversationTitle(conv) {
  if (conv.kind === 'group') return conv.title || 'Группа'
  // Деталей участников в списке нет — сервер кладёт название
  // собеседника в title для direct; страховка на пустое.
  return conv.title || 'Личный диалог'
}

function preview(conv) {
  const m = conv.last_message
  if (!m) return ''
  if (m.deleted) return 'Сообщение удалено'
  if (m.kind === 'system') return m.body
  return m.body || 'Вложение'
}

export default function ChatListPage() {
  const navigate = useNavigate()
  const { items, loading, error, refresh } = useConversations()

  return (
    <div className="chat-list-screen">
      <PageHeader title="Чат" />

      {loading && (
        <div className="chat-list-screen__state">
          <span className="spinner" aria-label="Загрузка" />
        </div>
      )}

      {!loading && error && (
        <div className="chat-list-screen__state">
          <p className="text-muted">{error}</p>
          <button type="button" className="btn btn--secondary" onClick={refresh}>
            Повторить
          </button>
        </div>
      )}

      {!loading && !error && items.length === 0 && (
        <div className="chat-list-screen__state">
          <Icon name="chat" size={40} />
          <p className="text-muted">
            Пока пусто. Диспетчер добавит вас в группу — диалог появится здесь.
          </p>
        </div>
      )}

      {!loading && !error && items.length > 0 && (
        <div className="chat-list-screen__items">
          {items.map((conv) => (
            <ConversationListItem
              key={conv.id}
              conversation={conv}
              title={conversationTitle(conv)}
              subtitle={preview(conv)}
              timeLabel={messageTimeLabel(conv.last_message_at)}
              muted={conv.muted_until && new Date(conv.muted_until) > new Date()}
              onClick={() => navigate(`/chat/${conv.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
